import type { CountDownProps, ItemProps } from './types.js'
import { cn } from '../../helpers/utils.js'
import { Picture } from '../../components/index.js'
import useCountDown from '../../hooks/useCountDown.js'

const Item = ({ time, copy, image, cns }: ItemProps) => (
  <>
    {time ? (
      <div
        className={cn(
          'cpn-countdown-item laptop:size-[54px] tablet:size-[3.2vw] relative size-[34px] rounded bg-black',
          cns?.item
        )}
      >
        {image && (
          <Picture
            className={cn('cpn-countdown-picture absolute left-0 top-0 size-full', cns?.picture)}
            imgClassName={cn('cpn-countdown-image h-full object-cover', cns?.image)}
            source={`${image}`}
            alt=""
          />
        )}
        <div
          className={cn(
            'cpn-countdown-time tablet:text-[1.25vw] laptop:text-[24px] absolute left-0 top-0 flex size-full items-center justify-center text-[16px] font-[600] text-white',
            cns?.time
          )}
        >
          {time}
        </div>
        {copy && (
          <div
            className={cn(
              'cpn-countdown-copy tablet:text-[12px] laptop:text-[14px] tablet:-bottom-6 absolute -bottom-4 left-1/2 -translate-x-1/2 text-[9px] font-medium',
              cns?.copy
            )}
          >
            {copy}
          </div>
        )}
      </div>
    ) : (
      <div className={cn('cpn-countdown-colonBox relative flex flex-col gap-1', cns?.colonBox)}>
        {Array.from({ length: 2 }).map((_, index) => (
          <span key={index} className={cn('cpn-countdown-colon size-1 rounded-full bg-black', cns?.colon)}></span>
        ))}
      </div>
    )}
  </>
)

const CpnCountDown = (props: CountDownProps) => {
  const { endTime, copy, cns, expiredHidden } = props

  const { days, hours, minutes, seconds } = useCountDown({ endTime })

  return (
    <div
      className={cn(
        'cpn-countdown-container laptop:gap-4 relative flex items-center justify-center gap-2',
        {
          'mb-5': copy?.days,
          '!hidden': expiredHidden && days === '00' && hours === '00' && minutes === '00' && seconds === '00',
        },
        cns?.container
      )}
    >
      <Item time={days} copy={copy?.days} cns={cns} />
      <Item cns={cns} />
      <Item time={hours} copy={copy?.hours} cns={cns} />
      <Item cns={cns} />
      <Item time={minutes} copy={copy?.minutes} cns={cns} />
      <Item cns={cns} />
      <Item time={seconds} copy={copy?.seconds} cns={cns} />
    </div>
  )
}

export default CpnCountDown
